import { render, staticRenderFns } from "./TipsBank.vue?vue&type=template&id=407f2ba8&scoped=true"
import script from "./TipsBank.vue?vue&type=script&lang=js"
export * from "./TipsBank.vue?vue&type=script&lang=js"
import style0 from "./TipsBank.vue?vue&type=style&index=0&id=407f2ba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f2ba8",
  null
  
)

export default component.exports